<template>
    <div class="pageAssets flex-col">
      <div class="box_3 flex-col">
        <div class="image-text_1 flex-row justify-between">
          <img
            class="image_1"
            referrerpolicy="no-referrer"
            src="@/assets/SketchPng978d3889c18f054a63e09bfd1e144aff63a3bfbaaf2abb2ab049da9748eed2a9.png"
          />
          <span class="text-group_1">{{$t('components_menu_10')}}</span>
        </div>
        <!-- <div class="box_4 flex-row justify-between">
          <div class="image-text_2 flex-row justify-between">
            <img
              class="icon_4"
              referrerpolicy="no-referrer"
              src="@/assets/SketchPng34edf7e8ca7c0d117d6ecad0a2ca6409eacd91b9291237d159f8a83d5fc65ab6.png"
            />
            <span class="text-group_2">{{$t('views_myassets_index_62')}}</span>
          </div>
          <button class="button_1 flex-col" @click="withdrawStaticToken" :style="{opacity:withdrawStaticTokenEnable?1:0.5}">
            <span class="text_3">{{$t('views_myassets_index_63')}}</span>
             <img
              class="icon_5"
              referrerpolicy="no-referrer"
              src="@/assets/SketchPng015a3e9e798038889f166c64aa48762109e703d80fe506aedbda82224b657096.png"
            /> 
          </button>
        </div> -->
      </div>
      <div class="box_5 flex-col">
        <div class="block_1 flex-col">
          <div class="box_6 flex-row justify-between">
            <div class="image-text_3 flex-row justify-between">
              <img
                class="icon_6"
                referrerpolicy="no-referrer"
                src="@/assets/e0957dfe5b7742928bf81d64906d6057_mergeImage.png"
              />
              <span class="text-group_3">{{$t('components_menu_10')}}</span>
            </div>
            <div class="image-text_4 flex-row justify-between">
              <span class="text-group_4" @click="$router.push({'name':'receiverecord'})">{{$t('views_myassets_index_64')}}</span>
              &nbsp;
              <img
                class="icon_7"
                referrerpolicy="no-referrer"
                src="@/assets/SketchPng1f9a53fffe18ed581e3b21c787b8ac872612a8aeded8fc994fe70f6cd5a08f37.png"
              />
            </div>
          </div>
          <div class="box_7 flex-row justify-between">
            <!-- <img
              class="icon_8"
              referrerpolicy="no-referrer"
              src="@/assets/SketchPng35aba9edcdc4f289f721598431af6af3187398c974465c0a50a098dd8281d544.png"
            /> -->
            <span class="text_4">{{$t('wait_receive_SZC')}}</span>
          </div>
          <div class="text-wrapper_2">
            <span class="text_5">{{userInfo.unclaimed|coin}}</span>
          </div>
          <button class="button_2 flex-col" @click="withdrawStaticToken" :style="{opacity:withdrawStaticTokenEnable?1:0.5}">
            <span class="text_8">{{$t('views_myassets_index_63')}}</span></button
          ><span class="text_9">{{$t('totalSalesAmount')}} <b style="color: orangered;">{{ userInfo.performance|coin }}</b></span>
        </div>
      </div>
      <!-- <div class="box_8 flex-col">
        <div class="block_2 flex-row">
          <div class="image-text_5 flex-row justify-between">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              src="@/assets/dd50f7341f7747dab4377a9e5db41b0b_mergeImage.png"
            />
            <span class="text-group_5">{{$t('views_myassets_index_67')}}</span>
          </div>
        </div>
      </div> -->
      <!-- <div class="box_9 flex-col"> -->
        <!-- <div class="text-wrapper_3 flex-row justify-between">
          <span class="text_10">{{$t('views_myassets_index_68')}}</span>
          <span class="text_11">{{profitRewardDetails.lottery|coin}}</span>
        </div> -->
        <!-- <div class="text-wrapper_4 flex-row justify-between">
          <span class="text_12">{{$t('views_myassets_index_69')}}</span>
          <span class="text_13">{{profitRewardDetails.direct|coin}}</span>
        </div>
        <div class="text-wrapper_5 flex-row justify-between">
          <span class="text_14">{{$t('views_myassets_index_70')}}</span>
          <span class="text_15">{{profitRewardDetails.push|coin}}</span>
        </div> -->
        <!-- <div class="text-wrapper_7 flex-row justify-between">
          <span class="text_18">{{$t('views_myassets_index_71')}}</span>
          <span class="text_19">{{profitRewardDetails.star|coin}}</span>
        </div>
        <div class="text-wrapper_8 flex-row justify-between">
          <span class="text_20">{{$t('views_myassets_index_72')}}</span>
          <span class="text_21">{{profitRewardDetails.dividends|coin}}</span>
        </div>
        <div class="text-wrapper_9 flex-row justify-between">
          <span class="text_22">{{$t('views_myassets_index_73')}}</span>
          <span class="text_23">{{profitRewardDetails.flatLevel|coin}}</span>
        </div> -->
        <!-- <div class="text-wrapper_6 flex-row justify-between">
          <span class="text_16">{{$t('views_myassets_index_74')}}</span>
          <span class="text_17">{{profitRewardDetails.team|coin}}</span>
        </div>
      </div> -->
      <appFooter></appFooter>
    </div>
  </template>
<script>
import i18n from '../../locales/index'

import clock_wise from "@/config/mobile_sale_abi";
import test_coin from "@/config/usdt";
import { mapState } from "vuex";
import Web3 from "web3";
import { getMobileSaleContract, getCoinContract,getSaleStorageContract } from "@/utils/contract";
import { copyToClipboard } from "@/utils";
export default {
  computed: {
    ...mapState(['userAdd']),
    inviteLink() {
      return `${window.location.origin}/refer/${this.userAdd}`;
    },
    withdrawReleaseTokenEnable(){
      return this.profitRewardDetails.total>0n&&this.userInfo.pendingDynamic>0n;
    }
  },
  watch: {
    userAdd() {
      this.initData();
    },
  },
  data() {
    return {
      userInfo: {},
      profitRewardDetails :{},
      withdrawStaticTokenEnable:false,//能否领取
      colddown: "",
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      if (!this.userAdd) return;
      // console.log('initData')
      this.getUserInfo();
      // this.profitReward();
      // this.getPledge();
    },
    async withdrawStaticToken() {
      if(!this.withdrawStaticTokenEnable)return;
      let loading = this.$loading()
      getMobileSaleContract().methods.claimSZCRewards().send({ from: this.userAdd }).then((r) => {
        this.$message.success(i18n.t('views_myassets_index_75'));
        this.getUserInfo();
        this.withdrawStaticTokenEnable=false;
        loading.close();
      }).catch(e=>{
        this.$message.error(i18n.t('views_myassets_index_76'));
        loading.close()
      })
    },
    async getUserInfo() {
      try {
        const contract = getSaleStorageContract();
        // 使用 getProductData 替代 checkUserInfo
        const userInfo = await contract.methods.users(this.userAdd).call({ from: this.userAdd });
        // console.log('userInfo',userInfo)
        this.userInfo = {
          unclaimed: userInfo.pendingSZCRewards || '0',
          pendingDynamic: userInfo.pendingDynamic || '0',
          performance: userInfo.totalSalesAmount || '0'
        };
        const rewardInfo = await contract.methods.getSZCRewardsInfo(this.userAdd).call({ from: this.userAdd });
        const colddown = await getMobileSaleContract().methods.szcClaimCooldown().call({ from: this.userAdd });
        if(rewardInfo.pendingRewards > 0){
          if(parseInt(rewardInfo.lastClaimTime) == 0){
            this.withdrawStaticTokenEnable = true;
          }else{
            if((parseInt(rewardInfo.lastClaimTime) + parseInt(colddown) * 1000) > Date.now()){
              this.withdrawStaticTokenEnable = false;
              let timer = setTimeout(()=>{
                let cdown = (parseInt(rewardInfo.lastClaimTime) + parseInt(colddown) * 1000) - Date.now();
                this.colddown = this.formatTime(cdown);
                if(cdown <= 0){
                  clearTimeout(timer);
                  this.withdrawStaticTokenEnable = true;
                }
              },1000);
            }else{
              this.withdrawStaticTokenEnable = true;
            }
          }
        } else {
          this.withdrawStaticTokenEnable = false;
        }
      } catch (error) {
        console.error('Error getting user info:', error);
        this.$message.error(this.$t('Failed to get user info'));
      }
    },

    formatTime(time){
      let hours = Math.floor(time / (1000 * 60 * 60));
      let minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((time % (1000 * 60)) / 1000);
      return `${hours}:${minutes}:${seconds}`;
    },
    async profitReward() {
      try {
        const contract = getSaleStorageContract();
        const data = await contract.methods.getSZCRewardsInfo(this.userAdd).call({ from: this.userAdd });
        // console.log('data',data)
        this.profitRewardDetails = {
          total: data.totalRewards || '0',
          direct: data.pendingRewards || '0',
          push: data.push || '0',
          team: data.team || '0'
        };
      } catch (error) {
        console.error('Error getting profit reward:', error);
        this.$message.error(this.$t('Failed to get profit reward'));
      }
    },
    async withdrawReleaseToken() {
      if(!this.withdrawReleaseTokenEnable)return;
      let loading = this.$loading()
      getMobileSaleContract().methods.claimTeamReward().send({ from: this.userAdd }).then((r) => {
        this.$message.success(i18n.t('views_myassets_index_75'));
        this.profitReward();
        //this.withdrawReleaseTokenEnable=false;
        loading.close();
      }).catch(e=>{
        this.$message.error(i18n.t('views_myassets_index_76'));
        loading.close()
      })
    },
    
    onClick_2() {
      alert(1);
    },
    copyInviteLink() {
      copyToClipboard(this.inviteLink)
    },
  },
};
</script>
<style lang="scss" src="@/scss/common.scss" />
<style lang="scss" src="./index.scss" />